const toMinutes = hhmm => {
  if (!/^\d{2}:\d{2}$/.test(hhmm || '')) return null
  const [h, m] = hhmm.split(':').map(Number)
  return h * 60 + m
}

export const validateFranja = ({ label, weekdays, starts_at, ends_at }) => {
  const errors = {}
  if (!label || !label.trim()) errors.label = 'label_required'
  else if (label.length > 100) errors.label = 'label_too_long'
  if (!weekdays || weekdays.length === 0) errors.weekdays = 'weekdays_required'
  const s = toMinutes(starts_at),
    e = toMinutes(ends_at)
  if (s === null || e === null || e <= s) errors.ends_at = 'end_after_start'
  return errors
}

// Half-open [start, end): abutting windows (13:00 / 13:00) do not overlap. Mirrors the API check.
export const overlappingFranja = ({ starts_at, ends_at, weekdays }, others) => {
  const s = toMinutes(starts_at),
    e = toMinutes(ends_at)
  if (s === null || e === null) return null
  const days = new Set((weekdays || []).map(Number))
  return (
    others.find(o => {
      if (!o.active) return false
      const os = toMinutes(o.starts_at),
        oe = toMinutes(o.ends_at)
      if (os === null || oe === null) return false
      const shared = (o.weekdays || []).some(d => days.has(Number(d)))
      return shared && s < oe && os < e
    }) || null
  )
}
